<template>
    <div class="ProductOnSale">
        <el-button class="marB10" @click="addFun" :class="baseerp+'btn'" size="mini">
            新增
        </el-button>
        <el-table
        ref="table"
        size="mini"
        :height="tableHeight"
        border
        :data="tableData"
        style="width: 100%">
            <el-table-column  show-overflow-tooltip
                    label="编号"
                    align="center"
                    prop="i_id" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="人员"
                    prop="vc_lruname">
            </el-table-column>
            <el-table-column
                    align="center"
                    label="录入时间"
                    prop="dt_createtime" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="状态"
                    :formatter="Status"
                    prop="i_state" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="操作" width="80" align="center">
                <template slot-scope="scope">
                    <el-button style="padding: 5px 10px"
                               size="mini"
                               type="text"
                               @click="details(scope.row)">查看</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination  style="margin-top: 10px;text-align: right"
                        background
                        @current-change="pageCurrentChange"
                        layout="total,prev, pager, next"
                        :current-page.sync="currentPage"
                        :total="total">
        </el-pagination>
        <div :class="baseerp+'div'">
            <el-dialog :title="title"
                       width="95%"
                       top="30px"
                       v-if="dialogTableVisible"
                       :visible.sync="dialogTableVisible"
                       :modal-append-to-body="false"
                       :close-on-click-modal="false">
                <add-dialog :add="add" @close="close" @getTrader="getTrader"></add-dialog>
            </el-dialog>
        </div>
    </div>

</template>

<script>
    import * as API from  "./api";
    import {baseerp} from "@/utils/baseUrl";
    import {filerequest_url} from './api';
    import {mapActions} from "vuex";
    import AddDialog from "./components/AddDialog";
    export default {
        name: 'ProductOnSale',
        components: {AddDialog},
        data(){
            return{
                baseerp:'',
                tableHeight:0,
                dialogTableVisible:false,
                add:{},
                title:"",
                tableData:[],
                pageSize:1,
                currentPage:1,
                total:0,
                pageCount: 10,


            }
        },
        mounted() {
            this.baseerp=baseerp;
            this.getTrader();
            this.$nextTick(function () {
                window.addEventListener('resize',this.heightAuto);
                this.heightAuto();
            });
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            heightAuto(){
                this.tableHeight = window.innerHeight - this.$refs.table.$el.clientTop - 280;
            },
            //获取已挂牌列表
            async getTrader(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id);
                } else {
                    this.mid = sessionStorage.getItem('mids');
                }
                let params={
                    page_size:this.pageSize,
                    page_count:15,
                    i_mid:this.mid
                };
                let res=await API.getTrader(params);
                if(res.code==1){
                    this.tableData=res.data;
                    this.total=res.total;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }

            },
            addFun(){
                this.title="新增挂牌";
                this.dialogTableVisible=true;
                this.add.i_id=0;
            },
            details(row){
                this.title="查看挂牌";
                this.dialogTableVisible=true;
                this.add=JSON.parse(JSON.stringify(row));

            },
            close(){
                this.dialogTableVisible=false;
            },
            pageCurrentChange(val){
                this.pageSize=val;
                this.currentPage=val;
            },
            Status(row, column, cellValue, index){
                if(row.i_state==0){
                    return '未提交'
                }else if(row.i_state==1){
                    return '审核中'
                }
            },

        },
        beforeDestroy() {
            window.removeEventListener('resize',this.heightAuto)
        },
    }
</script>

<style lang="scss" scoped>
    .text-ce{
        text-align: center;
    }
    .flex{
        display: flex;
        align-items: center;
    }
    .fl-wr{
        flex-wrap: wrap;
    }
    .marB10{
        margin-bottom: 10px;
    }
    .form-title{
        margin-left: 50px;
    }
    .ProductOnSale{
        background-color: #fff;
        padding: 10px 16px;
        ul,li{
            list-style: none;
            line-height: 0;
            padding: 0;
        }
        li{
            padding-right: 10px;
            padding-bottom: 10px;
        }
        /deep/{
            .el-dialog__body {
                padding: 10px 20px;
            }
            .el-dialog{
                min-width: 800px;
                margin: 0 auto 10px;
            }
            .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
                color: white;
            }
            .el-table__body .border_waring{
                border: 1px solid red;
                background-color: rgba(250,0,0,0.1);
            }
        }
    }
    /deep/{
        .el-table__body td{
            overflow: hidden;
        }
    }
    .el-table .cell{
        overflow:visible!important;
    }
    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
    }

</style>